module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-8.bd460ef8.png";